export const getPaymentMethodDisplay = (m: string) => {
  switch (m) {
    case 'cash':
      return `現金`;
    case 'credit_card_3d_secure_dgft_veri-trans4g_mdk':
      return `クレジットカード`;
    case 'paypay_dgft_veri-trans4g_mdk':
      return `PayPay`;
    case 'bnpl':
      return `後払い`;
    case 'no_charge':
      return `クーポン`;
    default:
      return `不明`;
  }
};
